var _style, _symbol, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitpad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.digitpad-st0{fill:#808080;}\r\n\t.digitpad-refrect{opacity:0;fill:#808080;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol",
    viewBox: "-64.5 -87.5 129 175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M-41,50.5h-10c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5V64 C-27.5,56.6-33.6,50.5-41,50.5z M-51,84.5c-5.8,0-10.5-4.7-10.5-10.5V64c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M5,50.5H-5c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5H5c7.4,0,13.5-6.1,13.5-13.5V64 C18.5,56.6,12.4,50.5,5,50.5z M-5,84.5c-5.8,0-10.5-4.7-10.5-10.5V64c0-5.8,4.7-10.5,10.5-10.5H5c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M51,50.5H41c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5V64 C64.5,56.6,58.4,50.5,51,50.5z M41,84.5c-5.8,0-10.5-4.7-10.5-10.5V64c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M5,4.5H-5c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5H5c7.4,0,13.5-6.1,13.5-13.5V18 C18.5,10.6,12.4,4.5,5,4.5z M-5,38.5c-5.8,0-10.5-4.7-10.5-10.5V18c0-5.8,4.7-10.5,10.5-10.5H5c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M5-41.5H-5c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5H5c7.4,0,13.5-6.1,13.5-13.5v-10 C18.5-35.4,12.4-41.5,5-41.5z M-5-7.5c-5.8,0-10.5-4.7-10.5-10.5v-10c0-5.8,4.7-10.5,10.5-10.5H5c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M-41,4.5h-10c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5V18 C-27.5,10.6-33.6,4.5-41,4.5z M-51,38.5c-5.8,0-10.5-4.7-10.5-10.5V18c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M-41-41.5h-10c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5v-10 C-27.5-35.4-33.6-41.5-41-41.5z M-51-7.5c-5.8,0-10.5-4.7-10.5-10.5v-10c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M51,4.5H41c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5V18 C64.5,10.6,58.4,4.5,51,4.5z M41,38.5c-5.8,0-10.5-4.7-10.5-10.5V18c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M51-41.5H41c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5h10c7.4,0,13.5-6.1,13.5-13.5v-10 C64.5-35.4,58.4-41.5,51-41.5z M41-7.5c-5.8,0-10.5-4.7-10.5-10.5v-10c0-5.8,4.7-10.5,10.5-10.5h10c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "digitpad-st0",
    d: "M5-87.5H-5c-7.4,0-13.5,6.1-13.5,13.5v10c0,7.4,6.1,13.5,13.5,13.5H5c7.4,0,13.5-6.1,13.5-13.5v-10 C18.5-81.4,12.4-87.5,5-87.5z M-5-53.5c-5.8,0-10.5-4.7-10.5-10.5v-10c0-5.8,4.7-10.5,10.5-10.5H5c5.8,0,10.5,4.7,10.5,10.5v10 c0,5.8-4.7,10.5-10.5,10.5H-5z"
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "digitpad-refrect",
    width: 36,
    height: 36
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 129,
    height: 175,
    x: -64.5,
    y: -87.5,
    transform: "matrix(0.1929 0 0 -0.1929 17.8488 18.125)",
    style: {
      overflow: "visible"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitpad);
export default __webpack_public_path__ + "static/media/digitpad.255f9244.svg";
export { ForwardRef as ReactComponent };